var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { on: { submit: _vm.submit } },
    [
      _c(
        "v-banner",
        { staticClass: "opportunity-user-input", attrs: { sticky: "" } },
        [
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_date"
              ),
              "detail-value": [_vm.parseDate(_vm.form["applyInfoApplyDate"])]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_shipping_address"
              ),
              "detail-value": [
                "〒 " +
                  _vm.form["shippingAddressInfoZip1"] +
                  "-" +
                  _vm.form["shippingAddressInfoZip2"],
                _vm.form["shippingAddressInfoAddress1"] +
                  " " +
                  _vm.form["shippingAddressInfoAddress2"] +
                  " " +
                  _vm.form["shippingAddressInfoAddress3"]
              ]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_seihin"
              ),
              "detail-value": [
                _vm.$t("view.sales_force.reflect.label.contract.standard")
              ]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_period"
              ),
              "detail-value": [_vm.getPlanName()]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_ninsu"
              ),
              "detail-value": [_vm.form["applyInfoApplyCapacityStandard"]]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.contract_form.update.label.apply_info.start_date"
              ),
              "detail-value": [
                _vm.parseDate(_vm.form["applyInfoStandardStartDate"])
              ]
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider", { staticClass: "mt-2" }),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.opportunity_id"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "8", md: "4" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  disabled: true,
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.opportunity.opportunity_id"
                  ),
                  placeholder: _vm.$t(
                    "view.sales_force.reflect.placeholder.opportunity.opportunity_id"
                  ),
                  autocomplete: "off"
                },
                model: {
                  value: _vm.salesForceInfo.opportunityStandardId,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "opportunityStandardId", $$v)
                  },
                  expression: "salesForceInfo.opportunityStandardId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
              attrs: { cols: "12", sm: "4", md: "4" }
            },
            [
              _c("move-sales-force-button", {
                attrs: {
                  "sales-force-id": _vm.salesForceInfo.opportunityStandardId,
                  "sales-force-type": "Opportunity"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.opportunity_line_item_id"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "8", md: "4" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.opportunity.opportunity_line_item_id"
                  ),
                  placeholder: _vm.$t(
                    "view.sales_force.reflect.placeholder.opportunity.opportunity_line_item_id"
                  ),
                  autocomplete: "off"
                },
                model: {
                  value: _vm.salesForceInfo.opportunityStandardItemId,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.salesForceInfo,
                      "opportunityStandardItemId",
                      $$v
                    )
                  },
                  expression: "salesForceInfo.opportunityStandardItemId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
              attrs: { cols: "12", sm: "4", md: "4" }
            },
            [
              _c("move-sales-force-button", {
                attrs: {
                  "sales-force-id":
                    _vm.salesForceInfo.opportunityStandardItemId,
                  "sales-force-type": "OpportunityLineItem"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.opportunity_name"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "8", md: "4" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.opportunity.opportunity_name"
                  ),
                  placeholder: _vm.$t(
                    "view.sales_force.reflect.placeholder.opportunity.opportunity_name"
                  ),
                  autocomplete: "off"
                },
                model: {
                  value: _vm.salesForceInfo.opportunityStandardName,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "opportunityStandardName", $$v)
                  },
                  expression: "salesForceInfo.opportunityStandardName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.price_book.price_book_select"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("price-book-select", {
                attrs: { "price-book-items": _vm.priceBookData },
                model: {
                  value: _vm.salesForceInfo.standardPriceBook2Id,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "standardPriceBook2Id", $$v)
                  },
                  expression: "salesForceInfo.standardPriceBook2Id"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.product"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("product-select", {
                attrs: {
                  "price-book-id": _vm.salesForceInfo.standardPriceBook2Id,
                  product: _vm.$t(
                    "view.sales_force.reflect.label.opportunity.standard"
                  ),
                  capacity: _vm.form.applyInfoApplyCapacityStandard,
                  period: _vm.getSalesForcePeriod()
                },
                on: {
                  "price-change": _vm.standardPriceChange,
                  "product-change": _vm.productChange,
                  "entry-change": _vm.entryChange
                },
                model: {
                  value: _vm.salesForceInfo.standardProductId,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "standardProductId", $$v)
                  },
                  expression: "salesForceInfo.standardProductId"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.price"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  disabled: "",
                  "error-messages": _vm.getPriceErrorMsg(),
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.price_kobetu"
                  ),
                  autocomplete: "off",
                  type: "number",
                  suffix: _vm.$t("view.sales_force.reflect.label.contract.yen")
                },
                model: {
                  value: _vm.salesForceInfo.standardPrice,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "standardPrice", $$v)
                  },
                  expression: "salesForceInfo.standardPrice"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.apply_start_date"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  disabled: true,
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.apply_start_date"
                  ),
                  type: "date"
                },
                model: {
                  value: _vm.salesForceInfo.standardContractStartDate,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.salesForceInfo,
                      "standardContractStartDate",
                      $$v
                    )
                  },
                  expression: "salesForceInfo.standardContractStartDate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.request_start_date"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.request_start_date"
                  ),
                  type: "date"
                },
                model: {
                  value: _vm.salesForceInfo.standardRequestStartDate,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.salesForceInfo,
                      "standardRequestStartDate",
                      $$v
                    )
                  },
                  expression: "salesForceInfo.standardRequestStartDate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.contract_edate"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.contract_edate"
                  ),
                  type: "date"
                },
                model: {
                  value: _vm.salesForceInfo.standardContractEdate,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "standardContractEdate", $$v)
                  },
                  expression: "salesForceInfo.standardContractEdate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3  align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.bunkatsu"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-checkbox", {
                staticClass: "mt-0",
                attrs: {
                  "persistent-hint": "",
                  "input-value": _vm.salesForceInfo.standardBunkatuFlg,
                  value: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.bunkatsu.value"
                  ),
                  label: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.bunkatsu.label"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.standardBunkatuFlg,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "standardBunkatuFlg", $$v)
                  },
                  expression: "salesForceInfo.standardBunkatuFlg"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3  align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.it_flg"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-checkbox", {
                staticClass: "mt-0",
                attrs: {
                  "persistent-hint": "",
                  disabled: _vm.standardItFlgDisabled,
                  "input-value": _vm.salesForceInfo.standardItFlg,
                  value: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.it_flg.value"
                  ),
                  label: _vm.$t(
                    "view.sales_force.reflect.data_labels.contract.it_flg.label"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.standardItFlg,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "standardItFlg", $$v)
                  },
                  expression: "salesForceInfo.standardItFlg"
                }
              }),
              _vm._v(" "),
              _vm.standardItFlgDescription
                ? _c("label", { staticClass: "caption red--text" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "view.sales_force.reflect.msg.select_two_years_item"
                          )
                        ) +
                        "\n            "
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 fixed-label-area align-center",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold fixed-label ml-4" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.tokubetu_detail"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-textarea", {
                staticClass: "mt-0",
                attrs: {
                  outlined: "",
                  rows: "2",
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.tokubetu_detail"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.standardTokubetuDetail,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "standardTokubetuDetail", $$v)
                  },
                  expression: "salesForceInfo.standardTokubetuDetail"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("sales-force-button-area", {
        attrs: { "disable-csv-output": true },
        on: { reflect: _vm.submit, "re-correct": _vm.reCorrect }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showConfirmDialog,
          "max-width": "800",
          "default-msg": _vm.confirmMessage
        },
        on: {
          "ok-click": function($event) {
            return _vm.reflect()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showAlertDialog,
          "max-width": "800",
          "is-confirm": false,
          "default-msg": _vm.alertMessage
        },
        on: {
          "ok-click": function($event) {
            return _vm.dialogClose()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-796b2cce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-796b2cce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales_force/OpportunityStandard.vue
// module id = vbMo
// module chunks = 1